import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { SessionContext } from "../context/sessionContext";

const Deactivation = () => {
  const { isDeactivated, resetDeactivated } = useUser();
  const { logout } = useContext(SessionContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isDeactivated) {
      const timer = setTimeout(async () => {
        resetDeactivated();
        await logout();
        navigate("/log-in");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isDeactivated]);

  if (!isDeactivated) return null;

  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "rgba(0,0,0,0.75)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999,
    }}>
      <div style={{
        background: "#1e293b",
        border: "1px solid #334155",
        borderRadius: "16px",
        padding: "2.5rem",
        maxWidth: "440px",
        width: "90%",
        textAlign: "center",
      }}>
        <h2 style={{ color: "#f8fafc", fontSize: "1.25rem", marginBottom: "0.75rem" }}>
          Your Account Has Been Deactivated
        </h2>
        <p style={{ color: "#94a3b8", fontSize: "0.95rem", lineHeight: "1.6" }}>
          To reactivate your account, please contact your organisation admin. You will be logged out shortly.
        </p>
      </div>
    </div>
  );
};

export default Deactivation;